// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/update_vision_project.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/update_vision_project.proto.
 */
export const file_vision_projects_v1_update_vision_project: GenFile = /*@__PURE__*/
  fileDesc("Ci52aXNpb24vcHJvamVjdHMvdjEvdXBkYXRlX3Zpc2lvbl9wcm9qZWN0LnByb3RvEhlwcm90b3MudmlzaW9uLnByb2plY3RzLnYxItwBChpVcGRhdGVWaXNpb25Qcm9qZWN0UmVxdWVzdBJMCgZwYXJhbXMYASABKAsyPC5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLlVwZGF0ZVZpc2lvblByb2plY3RSZXF1ZXN0LlBhcmFtcxIvCgt1cGRhdGVfbWFzaxgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2saPwoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSDAoEbmFtZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCSJ2ChtVcGRhdGVWaXNpb25Qcm9qZWN0UmVzcG9uc2USTQoGcmVzdWx0GAEgASgLMj0ucHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MS5VcGRhdGVWaXNpb25Qcm9qZWN0UmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z", [file_google_protobuf_field_mask]);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionProjectRequest
 */
export type UpdateVisionProjectRequest = Message<"protos.vision.projects.v1.UpdateVisionProjectRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.UpdateVisionProjectRequest.Params params = 1;
   */
  params?: UpdateVisionProjectRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionProjectRequest.
 * Use `create(UpdateVisionProjectRequestSchema)` to create a new message.
 */
export const UpdateVisionProjectRequestSchema: GenMessage<UpdateVisionProjectRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_project, 0);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionProjectRequest.Params
 */
export type UpdateVisionProjectRequest_Params = Message<"protos.vision.projects.v1.UpdateVisionProjectRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionProjectRequest.Params.
 * Use `create(UpdateVisionProjectRequest_ParamsSchema)` to create a new message.
 */
export const UpdateVisionProjectRequest_ParamsSchema: GenMessage<UpdateVisionProjectRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_project, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionProjectResponse
 */
export type UpdateVisionProjectResponse = Message<"protos.vision.projects.v1.UpdateVisionProjectResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.UpdateVisionProjectResponse.Result result = 1;
   */
  result?: UpdateVisionProjectResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionProjectResponse.
 * Use `create(UpdateVisionProjectResponseSchema)` to create a new message.
 */
export const UpdateVisionProjectResponseSchema: GenMessage<UpdateVisionProjectResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_project, 1);

/**
 * @generated from message protos.vision.projects.v1.UpdateVisionProjectResponse.Result
 */
export type UpdateVisionProjectResponse_Result = Message<"protos.vision.projects.v1.UpdateVisionProjectResponse.Result"> & {
};

/**
 * Describes the message protos.vision.projects.v1.UpdateVisionProjectResponse.Result.
 * Use `create(UpdateVisionProjectResponse_ResultSchema)` to create a new message.
 */
export const UpdateVisionProjectResponse_ResultSchema: GenMessage<UpdateVisionProjectResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_update_vision_project, 1, 0);

